
import STRINGS from "../../utils/strings";
import CancelButton from "../buttons/CancelButton";
import SaveButton from "../buttons/SaveButton";

export default function EditCellActions({ index, onSave, onDone }) {
  return (
    <div className="flex w-1/2 flex-row justify-end gap-2 px-2 py-4">
      <CancelButton className="w-1/2" disabled={false} onClick={onDone} />
      <SaveButton
        className="w-1/2"
        disabled={false}
        onClick={()=>onSave(index)}
        label={STRINGS.BUTTON_LABELS.SAVE}
      />
    </div>
  );
}
